// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/walking-down.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const walkingDown: Score = {
  slug: "walking-down",
  n: 25,
  title: "Walking Down",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 88,
  staves: 1,
  clefs: ["bass"],
  bars: 8,
  barQuarters: 4.0,
  lowest: 43,
  highest: 60,
  hasLyrics: false,
  jasonNote: "A walking bass \u2014 one note per beat, steady as footsteps. This one travels the whole stave, top line to bottom and back, so by the end you will have read every line and every space in the bass clef.",
  teaches: [
    "reading the whole bass stave",
    "steady walking crotchets",
    "lines and spaces below middle C"
  ],
  art: "/sight-reading/art/walking-down.jpg",
  artRights: "stock-free",
  background: "/sight-reading/bg/walking-down.jpg",
  newForThisEdition: true,
  fillsGap: "No piece in the printed book reads the bass stave alone.",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 2, hand: "rh", start: 6.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 2, hand: "rh", start: 7.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 47, pitch: "B2", d: "quarter" },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 4, hand: "rh", start: 12.0, dur: 2.0, midi: 53, pitch: "F3", d: "half" },
    { bar: 4, hand: "rh", start: 14.0, dur: 2.0, midi: 55, pitch: "G3", d: "half" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 57, pitch: "A3", d: "quarter" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter" },
    { bar: 5, hand: "rh", start: 18.0, dur: 1.0, midi: 53, pitch: "F3", d: "quarter" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 52, pitch: "E3", d: "quarter" },
    { bar: 6, hand: "rh", start: 20.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 6, hand: "rh", start: 21.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 6, hand: "rh", start: 22.0, dur: 1.0, midi: 47, pitch: "B2", d: "quarter" },
    { bar: 6, hand: "rh", start: 23.0, dur: 1.0, midi: 45, pitch: "A2", d: "quarter" },
    { bar: 7, hand: "rh", start: 24.0, dur: 1.0, midi: 43, pitch: "G2", d: "quarter" },
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 45, pitch: "A2", d: "quarter" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 47, pitch: "B2", d: "quarter" },
    { bar: 7, hand: "rh", start: 27.0, dur: 1.0, midi: 48, pitch: "C3", d: "quarter" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 48, pitch: "C3", d: "whole" },
  ],
};
